<script>
import icons from 'src/icons';

const validColored = ['primary', 'mainDark', 'mainLightThird', 'accent', 'red',
  'orange', 'green', 'blue', 'grey', 'lightAccent', 'socialVk', 'transpPrimary', 'transpGreen',
  'transpGrey', 'transpRed', 'transpBlack', 'transpDark'];
const validTheme = ['light', 'dark', 'transparent'];
const validType = ['icon', 'text', 'iconText'];
const validView = ['flat', 'raised'];
const validSize = ['middle', 'large'];

export default {
  props: {
    colored: {
      type: String,
      default: undefined,
      validator(value) {
        return validColored.includes(value);
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      validator(value) {
        return typeof icons[value] !== 'undefined';
      },
    },
    active: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'large',
      validator(value) {
        return validSize.includes(value);
      },
    },
    width: {
      type: String,
      default: '',
    },
    center: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: 'light',
      validator(value) {
        return validTheme.includes(value);
      },
    },
    type: {
      type: String,
      default: 'text',
      validator(value) {
        return validType.includes(value);
      },
    },
    view: {
      type: String,
      default: 'flat',
      validator(value) {
        return validView.includes(value);
      },
    },
  },
  methods: {
    onSubmit(e) {
      if (!this.disabled) this.$emit('submit', e);
    },
  },
};
</script>

<template lang="pug">
div(tabindex="0",
  :class="[$style.root, colored && $style[colored], theme && $style[theme], view && $style[view], disabled && $style.disabled, active && $style.active, type && $style[type], center && $style.center]",
  :style="!!width && {'max-width': width}"
  @click="onSubmit")
  ui-icon(v-if="icon", :class="$style.ico", :key="icon") {{ icon }}
  span(:class="[$style.content, size && $style[size]]", v-if="$slots.default")
    slot
</template>

<style module lang="sass">
.root
  position: relative
  display: inline-flex
  cursor: pointer
  user-select: none
  outline: none
  &:focus.root:after // проверить
    opacity: 0.9

.center
  display: flex
  align-items: center
  justify-content: center

.content
  line-height: 16px
  text-transform: uppercase
  letter-spacing: 0.02em
  padding: 10px 16px 8px
  color: inherit
  font-weight: 500
  text-overflow: ellipsis
  overflow: hidden
  white-space: nowrap

.middle
  font-size: 12px

.large
  font-size: 14px

.disabled
  pointer-events: none
  opacity: 0.5
  cursor: no-drop

.active
  opacity: 0.9

.text
  &:after
    content: ""
    border-radius: 3px
    background: currentColor
    position: absolute
    top: 0
    left: 0
    right: 0
    bottom: 0
    opacity: 0
    transition: opacity $a_speed

  &:hover.text:after
    opacity: 0.06

  &:focus.text:after
    opacity: 0

  &:active.text:after
    opacity: 0.25

.icon
  &:after
    content: ""
    border-radius: 50%
    background: currentColor
    position: absolute
    left: -8px
    bottom: -8px
    top: -8px
    right: -8px
    opacity: 0
    transition: opacity $a_speed

  &:hover.icon:after
    opacity: 0.06

  &:focus.icon:after
    opacity: 0.12

  &:active.icon:after
    opacity: 0.25

.iconText
  &:after
    content: ""
    border-radius: 3px
    background: currentColor
    position: absolute
    top: 0
    left: 0
    right: 0
    bottom: 0
    opacity: 0
    transition: opacity $a_speed

  &:hover.iconText:after
    opacity: 0.06

  &:focus.iconText:after
    opacity: 0.12

  &:active.iconText:after
    opacity: 0.25

  .ico
    margin: 6px 0 6px 11px

.ico
  color: currentColor
  height: 24px
  width: 24px

.accent
  background: $color_accent
  color: $white

.blue
  background: $color_blue
  color: $white

.green
  background: $color_green
  color: $white

.orange
  background: $color_orange
  color: $white

.primary
  background: $color_primary
  color: $white

.mainDark
  background: $color_main_dark

.red
  color: $white
  background: $color_red

.lightAccent
  background: $color_bg_light_accent_second

.socialVk
  color: $white
  background:$color_social_vk

.mainLightThird
  background: $color_main_light_third

.transpPrimary
  color: $color_primary

.transpGreen
  color: $color_green

.transpGrey
  color: $color_gray

.transpRed
  color: $color_red

.transpBlack
  color: $color_transparent_black

.transpDark
  color: $color_msg_dark
.grey
  background: #d8e1e5
</style>
